import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import OverflowText from "designSystem/components/text/OverflowText";
import Text from "designSystem/components/text/Text";
import React, { forwardRef, Fragment, RefObject } from "react";
import { useLocale } from "designSystem/locale";
import { itemListStyle } from "designSystem/styles/style-functions";
import { TooltipProps } from "../tooltip/Tooltip";

const PREFIX = "MenuItem";

const classes = {
	root: `${PREFIX}root`,
};

const StyledMuiMenuItem = styled(MuiMenuItem)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		...itemListStyle(theme),
		width: "100%",
	},
}));

export interface MenuItemProps extends Omit<MuiMenuItemProps, "button"> {
	/** the description of the item */
	description?: string;

	/** localization resource to use to lookup text; can be simple resource or type resource (i.e. "User.Name") */
	res?: string;

	/** parameters to pass if looking up resource */
	resParams?: Array<number | string>;

	/** the text of the item */
	text?: string;

	/** properties for tooltip */
	tooltipProps?: Partial<TooltipProps>;
}

const MenuItem = forwardRef((props: MenuItemProps, ref: RefObject<HTMLLIElement>) => {
	const {
		children,
		description,
		res,
		resParams,
		text,
		tooltipProps,
		...otherProps
	} = props;


	const value = res ? useLocale()
		.resource(res, resParams) : text;

	return (
		<StyledMuiMenuItem
			className={classes.root}
			ref={ref}
			{...otherProps}
		>
			{children || (
				<Fragment>
					<OverflowText text={value} tooltipProps={tooltipProps} />
					{description && <Text color="textSecondary" text={description} />}
				</Fragment>
			)}
		</StyledMuiMenuItem>
	);
});

export default MenuItem;